module.exports = __webpack_public_path__ + "img/feedback2.fad88c46.webp";